

// require("./lib/modernizr-custom.js");

/**
 * static includes
 *
 */
window.$ = window.jQuery          = require('jquery');

var basic 		= require("./chunk/basic.js");
var basic 		= require("./chunk/misc.js");
require('./lib/smoothscroll.min').polyfill();


require("./chunk/autogrow.js");
require('./chunk/offcanvas.js');
require('./chunk/slider__slick.js');

// var nav_anchor    = require('./chunk/nav_anchor.js');
var nav_scrollspy = require('./chunk/nav_scrollspy.js');
var parallax      = require('./chunk/parallax.js');


/**
 * Stickfill
 */
var Stickyfill = require("./lib/stickyfill-2.0.3.min.js");
var sticky_elements = $('.positionStickySidebar, .headerTop')
Stickyfill.add( sticky_elements );
 



/**
 * Smooth Scrolling
 * See https://developer.mozilla.org/en-US/docs/Web/Events/scroll
 * See https://www.kirupa.com/html5/smooth_parallax_scrolling.htm
 */
var last_known_scroll_position = 0;
var ticking = false;

if (!("scrollBehavior" in document.documentElement.style)) {
  require('smoothscroll-anchor-polyfill');
}

window.addEventListener('scroll', function(e) {
  last_known_scroll_position = window.scrollY;
 
  if (!ticking) {
    window.requestAnimationFrame(function() {
      
      if ( $('body.startseite').length ) {
        nav_scrollspy.init(last_known_scroll_position)
      }
      

      // if ( $('.has-headerTagline').length) {
      //   parallax.init(last_known_scroll_position)
      // }

      // nav_scrollspy.init(last_known_scroll_position)

      ticking = false;
    });
    ticking = true;
  }

},
{
    passive: true
});



/**
 * window.load
 *
 */
$(document).ready(function() {
  if ( $("body.startseite").length ) {
    last_known_scroll_position = window.scrollY;
    nav_scrollspy.init(last_known_scroll_position)
  }

  require("./chunk/photoswipe.js");
  require("./chunk/video_modal.js");
})

$(window).on("load",function(){
  // $('body').removeClass(' is-loading');
})



//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 0
// module chunks = 0